export * from './lib/browser-history.service.module';

export { AccredibleBrowserHistoryService } from './lib/browser-history.service';
